import React from 'react'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import withStyles from '@material-ui/core/styles/withStyles'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'

import { puzzleTypeItems, puzzleTurnItems, puzzleLevelItems } from '../../../constants'
import { WID, getWord } from '../../../constants/Language';
import Word from '../../../containers/Common/Word'


const styles = theme => ({
  textField: {
    width: 200,
  }
})

class PuzzleInfoDialog extends React.Component {
  render() {
    const { fullScreen, classes, open, puzzleInfo, disabled, dialogProps, textFieldProps, language } = this.props
    var items, levelHelperText
    items = puzzleLevelItems.filter((item) => item.value === puzzleInfo.level)
    levelHelperText = items.length > 0 ? getWord(items[0].wid, language) : ''
    return (
      <Dialog fullScreen={fullScreen} open={open} onClose={dialogProps.handleClose} onEnter={dialogProps.handleEnter}>
        <DialogTitle><Word wid={WID.PUZZLE_INFO_DIALOG.DIALOG_TITLE}/></DialogTitle>
        <DialogContent>
          <div>
            <TextField
              label={<Word wid={WID.PUZZLE_INFO_DIALOG.TURN_LABEL}/>}
              disabled={disabled}
              select
              onChange={textFieldProps.handleChangeText('selectedTurn')}
              value={puzzleInfo.selectedTurn}
              margin="normal"
              className={classes.textField}
            >
              {puzzleTurnItems.map((item, index) =>
                <MenuItem key={index} value={item.value}>
                  <Word wid={item.wid}/>
                </MenuItem>
              )}
            </TextField>
          </div>
          <div>
            <TextField
              label={<Word wid={WID.PUZZLE_INFO_DIALOG.PUZZLE_TYPE_LABEL}/>}
              disabled={disabled}
              select
              onChange={textFieldProps.handleChangeText('type')}
              value={puzzleInfo.type}
              margin="normal"
              className={classes.textField}
            >
              {puzzleTypeItems.map((item, index) =>
                <MenuItem key={index} value={item.value}>
                  <Word wid={item.wid}/>
                </MenuItem>
              )}
            </TextField>
          </div>
          <div>
            <TextField
              label={<Word wid={WID.PUZZLE_INFO_DIALOG.LEVEL_LABEL}/>}
              disabled={disabled}
              select
              onChange={textFieldProps.handleChangeText('level')}
              value={puzzleInfo.level}
              margin="normal"
              className={classes.textField}
              helperText={levelHelperText}
            >
              {puzzleLevelItems.map((item, index) =>
                <MenuItem key={index} value={item.value}>
                  {item.label}
                </MenuItem>
              )}
            </TextField>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={dialogProps.handleClose} color="primary" autoFocus>
              Cancel
          </Button>
          <Button onClick={dialogProps.handleOK(puzzleInfo)} color="primary" autoFocus>
              OK
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withMobileDialog()(withStyles(styles)(PuzzleInfoDialog))


// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/PuzzleInfoDialog.js